import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

type FindingUserImpactProps = {
  userImpact: string;
};

export default function FindingUserImpact({ userImpact }: FindingUserImpactProps) {
  return (
    <div className="rounded-r-md border-l-4 border-orange-300 bg-orange-50 p-3">
      <div className="flex items-start">
        <ExclamationTriangleIcon className="mr-2 mt-0.5 h-4 w-4 flex-shrink-0 text-orange-500" aria-hidden="true" />
        <div>
          <p className="mb-1 text-xs font-medium uppercase tracking-wide text-orange-700">User impact</p>
          <p className="text-sm leading-relaxed text-gray-700">{userImpact}</p>
        </div>
      </div>
    </div>
  );
}
